function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedundant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18267"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.558 19.173a.923.923 0 0 1-.923.923H20.1v1.538a.923.923 0 0 1-1.846 0V20.1h-1.542a.923.923 0 1 1 0-1.846h1.538v-1.542a.923.923 0 0 1 1.846 0v1.538h1.538a.923.923 0 0 1 .924.923z",
    transform: "rotate(-45 15.332 20.763)",
    style: {
      fill: "#0a243f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "add-product",
    d: "M25.019 15.192V5.635a3.387 3.387 0 0 0-3.384-3.385h-16A3.387 3.387 0 0 0 2.25 5.635v16a3.387 3.387 0 0 0 3.385 3.385h9.557a7.072 7.072 0 0 0 9.828-9.828zm-9.2-11.1a.925.925 0 0 0-.027.132V8c0 .311-.39.585-.836.585h-2.641c-.444 0-.836-.273-.836-.585V4.228a.807.807 0 0 0-.027-.132h4.361zM4.1 21.635v-16A1.541 1.541 0 0 1 5.635 4.1h4.027a.925.925 0 0 0-.027.132V8a2.569 2.569 0 0 0 2.682 2.431h2.638A2.569 2.569 0 0 0 17.636 8V4.228a.807.807 0 0 0-.027-.132h4.027a1.541 1.541 0 0 1 1.538 1.538v7.706a7.071 7.071 0 0 0-9.833 9.833H5.636A1.541 1.541 0 0 1 4.1 21.635zM19.173 24.4a5.231 5.231 0 1 1 5.227-5.227 5.237 5.237 0 0 1-5.227 5.227z",
    transform: "translate(-2.25 -2.25)",
    style: {
      fill: "#0a243f"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedundant);
export default __webpack_public_path__ + "static/media/redundant.6526225096626cea9c05a255958d3660.svg";
export { ForwardRef as ReactComponent };